import type { WebTemplateHref } from '@generalTypes/apiTypes';
import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { importanceComponent } from '@nodeTypeConfig/helpers/editComponents/importanceComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { webSitesWwwHref } from '@store/api/apiRoutes';
import { settings } from '../../settings';
import {
  wwwDefaultBuildingBlocks,
  wwwOmslagAndTegelFotoComps,
  wwwTitleAndDescriptionComps,
} from './wwwGenericConfigProps';

export const PRESS: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'Pers',
    plural: 'Pers',
    icon: require('../../../../img/icons/document.svg'),
  },
  onLoadActions: [loadWebConfigurations()],
  webconfiguration: {
    type: 'WWW_NEWS_DETAIL',
    website: {
      href: webSitesWwwHref,
    },
    template: {
      href: '/web/templates/514777b4-4657-4590-835e-7ff9d6e99b22' as WebTemplateHref,
    },
  },
  websiteHref: webSitesWwwHref,
  createModal: {
    authors: {
      addUser: true,
      required: true,
    },
  },
  tocTypes: [],
  buildingBlocks: wwwDefaultBuildingBlocks,
  edit: [
    ...wwwTitleAndDescriptionComps,
    ...wwwOmslagAndTegelFotoComps,
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
    importanceComponent,
  ],
  webTab: asideWebBasicConfiguration,
  customEditorOptions: {
    hideTermButton: true,
  },
  isCreatable: true,
  isSearchable: true,
  isImportable: true,
  allowSuggestions: false,
  websiteEdition: [
    {
      domain: settings.domains.www,
    },
  ],
};
